import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { emailRegex } from 'config';
import PubSub from 'services/PubSub/';

let regexEmail = emailRegex;
let timeout = null;

let actions = []

const InputEmail = forwardRef((props, ref) => {
    let showIcon = props.showIcon || false;
    const [value, setValue] = useState(props.value || '');
    const [isValid, setIsValid] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    let message = props.message.error || '';

    function showWarning() {
        setShowMessage(true)
        setIsValid(false)
        setValue('')

        setTimeout(() => {
            setShowMessage(false)
        }, 5000)
    }

    useEffect(() => {
        actions.push(PubSub.register('forceInputWarning_email', showWarning));

        return function cleanup() {
            actions = actions.map(token => PubSub.unregister(token));
            actions = [];
        };
    }, []);

    useEffect(() => {
        if(value && value.trim()){
            _onBlur();
        }
    }, []);

    const validateEmail = (_value) =>{
        let _isValid = true;

        if(!regexEmail.test(_value)){
            _isValid = false;
        }
        return _isValid;
    }

    const validateEmailOnChange = (_value) => {
        let _isValid = true;

        if(!regexEmail.test(_value)){
            _isValid = false;
        }
        return _isValid;
    }

    const _onChange = (event) => {
        let _value = event.target.value;

        setValue(event.target.value);
        setShowMessage(false);
        setIsValid(validateEmailOnChange ? validateEmailOnChange(_value) : isValid);
        props.validateForm();
        if(props.callbackValidate) {
            props.callbackValidate(validateEmail(_value));
        }

        clearTimeout(timeout);
        if(validateEmailOnChange && validateEmailOnChange(_value)){
            setShowMessage(true);
            props.validateForm();

        }else{
            timeout=setTimeout(()=>{
                setShowMessage(true);
                props.validateForm();
            }, 1000);
        }
    }

    const _onBlur = () => {
        if(!validateEmail) return false;
        setShowMessage(true);
        setIsValid(validateEmail(value));
        props.validateForm();
        if(props.callbackValidate){
            props.callbackValidate(validateEmail(value));
        }

    }

    useEffect(() => {
        if(props.value !== value){
            setValue(props.value);
        }
    },[props.value]);

    return (
        <div className={"input-wrapper short " + (!isValid && showMessage ? ' input-error'  : '')}>
            <label>
                <div className= {"label " + (props.required ? "required" : '')}>
                    {props.label}
                </div>
                <input
                    ref={ref}
                    type={props.type}
                    value={value}
                    name={props.name}
                    onChange={_onChange}
                    className={props.className}
                    onBlur={_onBlur}
                    placeholder = {props.placeholder || ''}
                />
                {(showIcon && isValid && (value !== '' )) && <i className="font-icn check-rounded"></i>}
                {!isValid && showMessage && <i className="jumbo-icon-new-close"></i>}
                <p className='input-error-message'>
                    {  message }
                </p>
            </label>
        </div>
    )

})

InputEmail.propTypes = {
    type: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    message: PropTypes.object,
    validateForm: PropTypes.func,
    placeholder: PropTypes.string,
    showIcon: PropTypes.bool,
    callbackValidate: PropTypes.func,
    required: PropTypes.bool
};

InputEmail.displayName = 'InputEmail';

export default InputEmail;
